module.exports = __webpack_public_path__ + "img/UHECampoNovos2.eda7c8c5.jpg";